<template>
    <section id="profile-side" class="position-relative d-flex flex-column h-100">
        <div style="position: absolute; top: 10px; right: 10px;">
            <CloseProfileSideIcon id="my-profile-close" @click.native="$emit('close')" />
        </div>
        <div class="side-content">
            <div class="d-flex">
                <div @dragover.prevent @drop.prevent="onImageUpload($event.dataTransfer.files[0])"
                    data-name="profile_image">
                    <label for="image">
                        <div>
                            <ProfilePicMask/>
                        </div>
                        <input
                            id="image"
                            type="file"
                            accept=".png, .jpg, .jpeg, .gif"
                            @change="onImageUpload($event.target.files[0])" class="d-none" />
                    </label>
                    <img v-if="cover" id="profile-image" :src="cover.url" style="width: 100%; height: 100%; object-fit: cover;"/>
                    <img v-else id="profile-image" :src="userPic" alt="" style="width: 100%; height: 100%; object-fit: cover;">
                    
                </div>
                <div data-name="image_desc">
                    <p>Profile Photo</p>
                    <p>Max. file size 500kb. <br> ratio 1x1 format</p>
                </div>
            </div>
            <div class="err-box text-center mt-3" v-if="uploadingError">
                    <span class="c5o7 p2bl">
                        {{uploadingError}}
                    </span>
            </div>
            <p class="email-info">
                <b>Email address: </b>
                <span>{{email}}</span>
            </p>
            <div data-name="info-change">
                <div data-name="title">
                    <p>Edit Your information</p>
                </div>
                <div data-name="inputs">
                    <a-input v-model="name" class="input" placeholder="Your Name" id="change-name-input-field"/>
                    <div data-name="whatsapp" class="d-flex">
                        <WhatsappIcon class="whatsapp-icon" />
                        <a-input v-model="whatsappNumber" id="whatsapp-number-input-field" data-name="whatsapp" placeholder="Whatsapp Number" class="input" />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="authUser && authUser.providerData && authUser.providerData[0].providerId !== 'google.com'" data-name="change-password">
            <ChangePassword />
        </div>
        <div data-name="side-footer" class="mt-auto">
            <div class="footer-content d-flex justify-content-between">
                <Button id="cancel-my-profile" @click.native="$emit('close')" type="download_outline">
                    Cancel
                </Button>
                <Button id="save-changes-my-profile" @click.native="updateUserData" type="request_button">
                    Save Changes
                </Button>
            </div>
        </div>
    </section>
</template>

<script>
    import {
        mapState,
        mapGetters
    } from 'vuex'
    import { message } from 'ant-design-vue'
    import {
        db,
        auth
    } from '../../../firebase'
    import Button from '../../Theme/Button'
    import ChangePassword from './ChangePassword'
    import {
        WhatsappIcon,
        CloseProfileSideIcon,
        ProfilePicMask
    } from '../../Icons'
    import { uploadImage } from "../../../firebaseCRUD";
    import {
        PROFILE_PIC_PLACEHOLDER,
        ICON_WARNING,
        ICON_CHECKMARK
    } from "../../../constants";
    import {validateUploading} from "../../../core/_validateUploading";
    export default {
        name: 'MyProfileDrawer',
        components: {
            WhatsappIcon,
            CloseProfileSideIcon,
            Button,
            ChangePassword,
            ProfilePicMask
        },
        data() {
            return {
                ICON_WARNING,
                ICON_CHECKMARK,
                name: null,
                email: null,
                cover: undefined,
                whatsappNumber: '',
                picUrl: null,
                errMessages: {},
                doneState: false,
                uploadingError: ''
            }
        },
        computed: {
            ...mapState([
                'user',
                'message'
            ]),
            ...mapGetters(['usersCollection']),
            authUser(){
                return auth.currentUser;
            },
            userPic(){
                return this.user.user_img || PROFILE_PIC_PLACEHOLDER
            }
        },
        watch: {
            'picUrl': 'uploadPhotoToFirebase',
        },
        mounted: function () {
            this.initUserData()
        },
        methods: {
            updateUserData: function () {
                if (!this.name || !this.name.length || !this.email || !this.email.length) {
                    return
                }

                message.success('Changes are saved')

                db
                    .collection(this.usersCollection)
                    .doc(this.user.uid)
                    .update({
                        name: this.name,
                        email: this.email,
                        whatsapp_number: this.whatsappNumber
                    })
            },
            onImageUpload (file) {
                if(!file) {
                    return;
                }
                this.uploadingError = validateUploading(file);
                if(this.uploadingError) {
                    return
                }
                this.cover = {
                    file,
                    url: URL.createObjectURL(file)
                }
                this.upload(file)
            },
            async upload(e) {
                try {
                    this.cover.url = this.picUrl = await uploadImage(e);
                } catch(err) {
                    this.$store.dispatch('handleErrors', err)
                }
            },
            uploadPhotoToFirebase () {
                auth.currentUser.updateProfile({
                    photoURL: this.picUrl
                })
                db.collection(this.usersCollection)
                    .doc(this.user.uid)
                    .update({
                        user_img: this.picUrl
                    })
            },
            initUserData: function () {
                this.name = this.user.name
                this.email = this.user.email
                this.whatsappNumber = this.user.whatsapp_number || ''
            },
            checkEmailValidation(val) {
                if (!val || val.length < 3) {
                    this.errMessages.emailErrMsg = null;
                    this.doneState = false;
                    return true;
                }
                let re = /\S+@\S+\.\S+/;
                if (re.test(val)) {
                    this.errMessages.emailErrMsg = null;
                    this.doneState = true;
                    return true;
                } else {
                    this.errMessages.emailErrMsg = "Something went wrong. Try again!";
                    this.doneState = false;
                    return false;
                }
            },
        }
    }
</script>

<style scoped lang="scss">
@import '../../../assets/scss/variables.scss';

section#profile-side {
    width: 100%;
    z-index: 99999;

    div.side-content {
        width: 340px;
        margin: 40px auto;

        .email-info{
            margin-top: 25px;
            font-size: 16px;
            color: #858585;
        }

        div[data-name='profile_image'] {
            width: 90px;
            height: 90px;
            border-radius: 50%;
            border: 4px solid #FFFFFF;
            box-shadow: 0px 1px 2px rgba(8, 35, 48, 0.24), 0px 2px 6px rgba(8, 35, 48, 0.16);
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            overflow: hidden;
            label {
                margin: 0;
                z-index: 2;

                img {
                    width: 80px;
                    height: 80px;
                    border-radius: 50px;
                    object-fit: cover;
                }
            }
            div {
                height: 26px;
                width: 80px;
                background: #0000005e;
                position: absolute;
                bottom: 0px;
                right: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 3;
            }
            
        }

        div[data-name="image_desc"] {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 35px;

            p {
                margin: 0;

                &:first-child {
                    font-size: $p3;
                    font-weight: bold;
                    color: $c7;
                }

                &:last-child {
                    margin-top: 10px;
                    color: $c9;
                    font-size: $p5;
                }
            }
        }

        div[data-name="info-change"] {
            margin-top: 45px;

            div[data-name="title"] {
                margin-bottom: 30px;

                p {
                    color: $c7;
                    font-size: $p2;
                    font-weight: bold;
                }
            }

            div[data-name="inputs"] {
                input {
                    font-size: $p4;
                    font-weight: bold;
                    color: $c7;
                    margin-bottom: 20px;
                }

                div[data-name="email-input"] {
                    position: relative;

                    input {
                        &.errState {
                            border: 1px solid $c5;
                            color: $c5;
                        }
                    }

                    div.err-box {
                        position: absolute;
                        top: 100%;
                        left: 0px;

                        p {
                            line-height: 1.2;
                        }
                    }

                    div.err-done-img {
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translate(-10px, -100%);
                    }
                }

                div[data-name="whatsapp"] {
                    position: relative;

                    input {
                        padding-left: 40px;
                    }

                    .whatsapp-icon {
                        position: absolute;
                        z-index: 1;
                        top: 50%;
                        left: 10px;
                        transform: translateY(-100%);
                    }

                }
            }
        }
    }

    div[data-name="change-password"] {
        padding-top: 30px;
        padding-bottom: 30px;
        background: $c11;
    }

    div[data-name="side-footer"] {
        background: $c11;
        border-top: 1px solid #EAE5F1;
        padding-top: 27px;
        padding-bottom: 47px;

        div.footer-content {
            width: 290px;
            margin: 0 auto;

            button {
                &:first-child {
                    padding: 11px 20px;
                }

                &:last-child {
                    padding: 11px 38px;
                    font-size: $p3;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>